import React /* , { useState, useEffect } */ from "react";

function Tabdati({ prodotto }) {
  const datiProd = prodotto[0];

  return (
    <div>
      <div className="mt3 f5 ttu b tc">Anagrafica</div>
      <div className="mt3 f5 ttu">
        <span className="b">Brand</span>
        <br />
        {datiProd.brand}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Codice produttore</span>
        <br />
        {datiProd.codProd}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Colore</span>
        <br />
        {datiProd.colore}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Persona</span>
        <br />
        {datiProd.persona}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Reparto</span>
        <br />
        {datiProd.reparto}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Categoria</span>
        <br />
        {datiProd.categoria}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Tipo</span>
        <br />
        {datiProd.tipo}
      </div>
      <div className="mt3 f5 ttu">
        <span className="b">Anno</span>
        <br />
        {datiProd.anno}
      </div>
    </div>
  );
}

export default Tabdati;
